import { 
    CouponApiFp,
    CouponControllerGet200Response,
    CreateCouponDto, 
    DeleteCouponDto,
    EditCouponDto,
    GetCouponDto, 
    MessageResponseDto, 
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseCouponModel = CouponControllerGet200Response;
export type GetCouponModel = GetCouponDto;
export type MutateResponseCouponModel = MessageResponseDto;
export type CreateCouponModel = CreateCouponDto;
export type UpdateCouponModel = EditCouponDto;
export type DeleteCouponModel = DeleteCouponDto;

export const apiCouponFp = CouponApiFp(apiConfig);
export const getCouponController = apiCouponFp.couponControllerGet;
export const createCouponController = apiCouponFp.couponControllerCreate;
export const updateCouponController = apiCouponFp.couponControllerEdit;
export const deleteCouponController = apiCouponFp.couponControllerDelete;

export const QueryKeyCoupon = QueryKey.Coupon;
